import {ADD_SUCCESS_MESSAGE, CLEAR_SUCCESS_MESSAGES, REMOVE_SUCCESS_MESSAGE} from 'state/actions';

export default function successMessagesReducer(state = [], action) {
  switch (action.type) {
    case ADD_SUCCESS_MESSAGE:
      const id = state.length !== 0 ? state[state.length - 1].id + 1 : 0;
      return [...state, {id, message: action.message}];
    case CLEAR_SUCCESS_MESSAGES:
      return [];
    case REMOVE_SUCCESS_MESSAGE:
      return state.filter(message => message.id !== action.id);
    default:
      return state;
  }
}
